export default __webpack_public_path__ + "static/media/mandala21.4f06a859.png";